import React from 'react'
import PropTypes from 'prop-types'

import { Table, TableBody, TableHeader,
  TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'

import LineItem from './LineItem'

export default class LineItemsList extends React.PureComponent {

  static propTypes = {
    jobInfo: PropTypes.object.isRequired,
    items: PropTypes.object.isRequired,
    totals: PropTypes.object.isRequired,
    onItemEdited: PropTypes.func.isRequired,
    onItemDelete: PropTypes.func.isRequired
  }

  getLineItems = () => {
    const items = this.props.items
    const result = []
    for (const key in items) {
      if (items.hasOwnProperty(key)) {
        const item = items[key]
        if (!item.deleted) {
          result.push(item)
        }
      }
    }
    return result
  }

  handleItemEdited = (item, newValues) => {
    this.props.onItemEdited(item, newValues)
  }
  
  handleItemDelete = (item) => {
    this.props.onItemDelete(item)
  }

  render() {
    const items = this.getLineItems()
    return (
      <Table>
        <TableHeader
          adjustForCheckbox={false}
          displaySelectAll={false}>
          <TableRow style={styles.headerRow}>
            <TableHeaderColumn colSpan={2} style={styles.header}>Item</TableHeaderColumn>
            <TableHeaderColumn colSpan={2}
              style={{ ...styles.header, ...styles.centeredHeader }}>
              Budgeted
            </TableHeaderColumn>
            <TableHeaderColumn colSpan={3}
              style={{ ...styles.header, ...styles.centeredHeader }}>
              Progress
            </TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          <TableRow style={styles.subHeaderRow} key='subHeader'>
            <TableRowColumn style={styles.subHeader} colSpan={2}></TableRowColumn>
            <TableRowColumn style={styles.subHeader}>Foreman</TableRowColumn>
            <TableRowColumn style={styles.subHeader}>Labor</TableRowColumn>
            <TableRowColumn style={styles.subHeader}>Foreman</TableRowColumn>
            <TableRowColumn style={styles.subHeader}>Labor</TableRowColumn>
            <TableRowColumn style={styles.subHeader}>%</TableRowColumn>
          </TableRow>
          { items.map((item, index) =>
            <LineItem
              key={item.id}
              index={index}
              jobInfo={this.props.jobInfo}
              item={item}
              itemAllocations={this.props.totals[item.id]}
              onItemEdited={this.handleItemEdited}
              onItemDelete={this.handleItemDelete} />
          )}
        </TableBody>
      </Table>
    )
  }

}

const styles = {
  
  header: {
    color: '#757575',
    fontWeight: 500,
    fontSize: 14
  },

  centeredHeader: {
    textAlign: 'center'
  },

  subHeader: {
    fontSize: 10,
    height: 18,
    color: '#757575',
    textAlign: 'center'
  },

  headerRow: {
    borderBottom: '1px solid #527da3'
  },

  subHeaderRow: {
    borderBottom: 'none',
    height: 18
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/lineItems/LineItemsList.js